<template>
    <div>
        <div class="table-box" style="padding:10px;">
            <Form width="100" :inline="true">
                <FormItem label="类型">
                    <RadioGroup v-model="searchForm.processor_type">
                        <Radio label="1">CPU</Radio>
                        <Radio label="2">GPU</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="姓名" width="80">
                    <Input type='text' placeholder="请输入姓名" v-model="searchForm.name"></Input>
                </FormItem>
                <FormItem>
                    <br />
                    <Button @click="getList()">查询</Button>
                </FormItem>
            </Form>
        </div>
        <div class="table-box">
            <Table   ref="selection" :columns="columns" :data="list.body"></Table>
            <!-- <br />
            <Button @click="showModal">勾选设置</Button> -->
            <div  class="page-box">
                <Page :total="list.page.count" :page-size="page_size" :page-num="page_num" @on-change="change_page" v-if="list.page"/>
            </div>
        </div>
        <!--修改弹窗-->
        <Modal
            v-model="show"
            title="修改时长"
            width="20"
            ok-text="修改"
            @on-ok="update">
            <Form>
                <FormItem label="可用时长">
                    <InputNumber :max="10000" :min="0" v-model="current_dura"></InputNumber>&nbsp;小时
                </FormItem>
            </Form>
        </Modal>
        <!----------->
    </div>
</template>
<style scoped lang="less">
    @import "../style/index";
</style>
<script>
    import {mapActions,mapState} from 'vuex'
    export default {
        name:'list',
        computed:{
            ...mapState({
                list:state => state.resource.list,
            })
        },
        data(){
            return {
                current_dura:0,
                show:false,
                searchForm:{
                    processor_type:"1",
                    name:'',
                },
                current:{},
                page_num:1,
                page_size:50,
                
                columns:[
                    // {
                    //     type: 'selection',
                    //     width: 60,
                    //     align: 'center'
                    // },
                    {
                        title:'名称',
                        key:'name',
                        width:100,
                    },
                    {
                        title:'可用时长',
                        key:'avail_dura'
                    },
                    {
                        title:"类型",
                        key:'processor_type',
                        render:(h,params)=>{
                            return h('p',
                            params.row.processor_type == 1 ?'CPU':"GPU"
                            )
                        }
                    },
                    {
                        title:'操作',
                        key:'action',
                        render:(h,params)=>{
                            return h('div',[
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.current = params.row;
                                            this.current_dura = params.row.avail_dura;
                                            this.show = true;
                                        }
                                    }
                                }, '设置'),
                            ])
                        }
                    }
                ],
            }
        },
        methods:{
            ...mapActions({
                getListResource:'resource/getList',
                updateDura:'resource/updateDura',
            }),
            handleSelectAll (status) {
                this.$refs.selection.selectAll(status);
            },
            showModal(){
                this.show = true;
                // this.currents = this.$refs.selection.getSelection();
                // console.log(this.currents);
                // if(this.currents.length == 0){
                    // this.$Message.success("请选择学生")
                // }else{
                    // this.show = true;
                // }
            },
            // 更新时长
            update(id){
                let _this = this;
                if( _this.current.id > 0 ){
                    this.updateDura({
                        data:{
                            id:_this.current.id,
                            data:{
                                processor_type:_this.current.processor_type,
                                avail_dura:_this.current_dura,
                                status:1,
                            }
                        },
                        callback:function(){
                            _this.$Message.success("时长更新完成");
                        },
                        error:function(msg){
                            _this.$Message.error(msg);
                        }
                    })
                }
            },
            change_page(page){
                this.page_num = page;
                this.getList();
            },
            // 获取列表
            getList(){
                let _this = this;
                this.getListResource({
                    data:{
                        name:_this.searchForm.name,
                        processor_type:_this.searchForm.processor_type,
                        sort:'-name|ctime',
                        page_num:_this.page_num,
                        page_size:_this.page_size
                        },
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                })
            }
        },
        created(){
            this.getList();
        },
    }
</script>